import { useEffect } from "react";
import { PromoCycleModalHeader } from "./PromoCycleModalHeader";
import { PromoCycleModalFormWrapper } from "./PromoCycleModalFormWrapper";

const PromoCycleModal = ({
  setOpenPromoCycleModal,
  promoCycleId,
  setPromoCycleId,
  getBookings
}) => {
  useEffect(() => {
    document.body.classList.add("modal-open");

    return () => {
      document.body.classList.remove("modal-open");
    };
  }, []);

  return (
    <>
      <div
        className="modal fade show d-block"
        id="kt_modal_add_user"
        role="dialog"
        tabIndex={-1}
        aria-modal="true"
      >
        {/* begin::Modal dialog */}
        <div className="modal-dialog modal-dialog-centered mw-850px">
          {/* begin::Modal content */}
          <div className="modal-content">
            <PromoCycleModalHeader
              setOpenPromoCycleModal={setOpenPromoCycleModal}
              setPromoCycleId={setPromoCycleId}
            />
            {/* begin::Modal body */}
            <div className="modal-body scroll-y mx-5 mx-xl-5 my-2 p-4">
              <PromoCycleModalFormWrapper
                promoCycleId={promoCycleId}
                setPromoCycleId={setPromoCycleId}
                setOpenPromoCycleModal={setOpenPromoCycleModal}
                getBookings={getBookings}
              />
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className="modal-backdrop fade show"></div>
      {/* end::Modal Backdrop */}
    </>
  );
};

export { PromoCycleModal };
